import LicenseInterface from "@/interfaces/License.interface";
import api from "@/services/config";

export class LicenseRest{
    getLicense(params: any): Promise<any> {
        return api.get('/license', { params }).then((response) => response.data);
    }
    
    getLicenseById(id: any): Promise<any> {
        return api.get(`/license/${id}`).then((response) => response.data);
    }

    addLicense(data: any): Promise<any> {
        return api.post('/license', data).then((response) => response.data);
    }

    updateLicense(id: any, data: LicenseInterface): Promise<any> {
        return api.put(`/license/${id}`, data).then((response) => response.data);
    }

    deleteLicense(id: any): Promise<LicenseInterface> {
        return api.delete(`/license/${id}`).then((response) => response.data);
    }

}